/**
 * Created by Mark on 18/04/2017.
 */

import LanguageServices from '../../services/language-services.js';
import LanguageStore from '../../store/language-store.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import '../../css/muilt-select.css';
import Select from  'react-select';
import InternationalizationStore from '../../store/internationalization-store.js';
export default class LanguageSelector extends React.Component {

    constructor(props){
        super();

        this.props = props;``
        this.state = {languages:[] , value :props.value || null, disabled:props.disabled || null, addAll:props.addAll || false}
        this.onSelect = this.onSelect.bind(this)
    }

    componentDidMount() {
        LanguageServices.getAllAvailableLanguages()
    }

    setCurr(id){
        LanguageServices.getLangForCurr(id);
    }

    componentWillMount(){
        LanguageStore.on("CHANGE" , () => {
            let languages = LanguageStore.getLearningLanguage();

            if (this.state.addAll){

                languages.unshift({ietf:"es-MX", getName:function(){return "Latam Spanish"}});
                languages.unshift({ietf:"bn", getName:function(){return "Bengali"}});
                languages.unshift({ietf:"ti", getName:function(){return "Tigrinya"}});
                

                languages.unshift({ietf:"All", getName:function(){return "All"}});
                
                
            }

            if (this.isCurr == true && LanguageStore.currLanguages != undefined){
                languages = LanguageStore.currLanguages;
            }


            this.setState({languages:languages});

            if(this.props.setSupport == true)
            {
                for(var idx = 0 ; idx < languages.length; idx++)
                {
                    if(languages[idx].ietf.indexOf(String(InternationalizationStore.determineLocaleFromBrowser().substring(0 , 2))) >= 0)
                    {
                        if(!this.state.value) this.onSelect({value:languages[idx].ietf , label: languages[idx].getName()  })
                        return
                    }
                }

                if(!this.state.value)this.onSelect({value:languages[0].ietf , label: languages[0].getName()  })
            }
            else
            {
                if(!this.state.value)this.onSelect({value:languages[0].ietf , label: languages[0].getName()  })
            }

        });
    }

    onSelect(option) {

        if (this.props.onSelect)
            if ((option.value == "All" || option.value == "es-MX" || option.value == 'bn' || option.value == 'ti') && this.state.addAll) {
                this.props.onSelect({ ietf: option.value });
            } else if (!this.props.multi) this.props.onSelect(LanguageStore.getLanguage(option.value), this.state.languages.length);
            else {
                console.log("here");
                this.props.onSelect(option);
            }

        this.setState({ value: option });
    }

    render(){
        if (this.state.disabled != null && this.state.disabled != undefined) {
            for (var i = 0; i < this.state.disabled.length; i++){
                for (var j = 0; j < this.state.languages.length; j++){
                    if (this.state.languages[j].ietf == this.state.disabled[i]){
                        this.state.languages.splice(j, 1);
                    }
                }
            }
        }

        let options = this.state.languages.map(function(language){
             return  { value: language.ietf, label: language.getName()}
        });




        return <Select multi={this.props.multi} disabled={this.state.languages.length <= 1} onChange={this.onSelect} className={this.props.className} 
                value={this.state.value} options={options} noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

}



// WEBPACK FOOTER //
// ./src/components/inputs/language-selector.js